import * as LabelPrimitive from '@radix-ui/react-label'
import { cva } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

// ADR-027 §2: the field label is the design's section label, 15/700
// muted in sentence case (fase 5b), with a 6px gap to the field below it
const labelVariants = cva(
	'text-muted-foreground mb-1.5 block text-[15px] leading-tight font-bold peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
)

const Label = ({
	className,
	...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) => (
	<LabelPrimitive.Root
		data-slot="label"
		className={cn(labelVariants(), className)}
		{...props}
	/>
)

export { Label }
